import { useQuery } from "@tanstack/react-query";
import type { DashboardManual } from "@arc/contracts";
import type { AuthSession } from "../../auth/keycloak.js";
import { dashboardApi } from "../../api/client.js";

/**
 * `GET /dashboard/manuals` (ADR-034 D1): every manual the caller can see as a light card — the Manuals, Favourite
 * manuals and Ratings pages sort, filter and group it client-side (one dataset, one cache). Fresh for a minute, then
 * refetched when the tab regains focus (explicit — the app's QueryClient default is off); `archived` is its own key.
 */
export function useDashboardManuals(session: AuthSession | null, archived = false) {
  return useQuery<DashboardManual[], Error>({
    queryKey: ["dashboard-manuals", session?.realm, session?.sub, archived],
    enabled: session !== null,
    staleTime: 60_000,
    refetchOnWindowFocus: true,
    queryFn: async () => {
      const res = await dashboardApi.listManuals({ query: { archived: archived ? "true" : "false" } });
      if (res.status !== 200) throw new Error(`GET /dashboard/manuals returned ${res.status}`);
      return res.body.manuals;
    },
  });
}
